var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLockKeyholeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1253 7.22217H6.87511V4.79173C6.87511 3.06578 8.27426 1.66663 10.0002 1.66663C11.2407 1.66663 12.3124 2.38939 12.8171 3.43677M10 13.3333V15M6.25 18.3333H13.7504C15.1311 18.3333 16.2504 17.214 16.2504 15.8333V9.72221C16.2504 8.34149 15.1311 7.22221 13.7504 7.22221H6.25C4.86929 7.22221 3.75 8.34149 3.75 9.7222V15.8333C3.75 17.214 4.86929 18.3333 6.25 18.3333ZM11.25 11.6666C11.25 12.357 10.6904 12.9166 10 12.9166C9.30964 12.9166 8.75 12.357 8.75 11.6666C8.75 10.9763 9.30964 10.4166 10 10.4166C10.6904 10.4166 11.25 10.9763 11.25 11.6666Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockKeyholeOpen);
export default __webpack_public_path__ + "static/media/lock-keyhole-open.d03287d3921e9aa5d894e9d30bd9642f.svg";
export { ForwardRef as ReactComponent };